import { FlyerDimensions } from "../types/arts";

export function dimensionsImage(url = ""): Promise<FlyerDimensions> {
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.src = url;

    image.onload = () =>
      resolve({ width: image.width, height: image.height, url });
    image.onerror = (error) => reject(error);
  });
}
